export default __webpack_public_path__ + "static/casestudy_1-2a4df8633ac3000c545eff3b512651bb.png";